import {head, isNotNil} from 'ramda';

import {
  CustomerMessageIdEnum,
  OAuthEmailCredentialsResponseBody,
  SmtpCredentialsResponseBody,
  useGetLastKnownSmtpCredentialsQuery,
  useListEmailCredentialsQuery,
} from '@dms/api/core';
import i18n from '@dms/i18n';

export const useSmtpOptions = (customerMessageId: CustomerMessageIdEnum) => {
  const {data: userSmtpCredentials, isLoading: isLoadingUserSmtpCredentials} =
    useListEmailCredentialsQuery({});

  const {data: lastKnownSmtpCredentials, isLoading: isLoadingLastKnownSmtpCredentials} =
    useGetLastKnownSmtpCredentialsQuery({customerMessageId});

  const smtpCredentials = userSmtpCredentials?.credentials ?? [];

  const firstSmtpCredentialId = head(smtpCredentials ?? [])?.id;
  const areLastUsedCredentialsValid =
    isNotNil(lastKnownSmtpCredentials) &&
    smtpCredentials.some((item) => item.id === lastKnownSmtpCredentials?.smtpCredentialsId);
  const defaultSmtpCredentialId = areLastUsedCredentialsValid
    ? lastKnownSmtpCredentials?.smtpCredentialsId
    : firstSmtpCredentialId;

  const smtpCredentialsOptions = [
    {
      label: i18n.t('general.labels.user'),
      options:
        smtpCredentials
          .filter((credential) => credential.ownerType === 'user')
          ?.map(credentialToOption) ?? [],
    },
    {
      label: i18n.t('page.homepage.labels.tenant'),
      options:
        smtpCredentials
          .filter((credential) => credential.ownerType === 'tenant')
          ?.map(credentialToOption) ?? [],
    },
  ];

  const isLoading = isLoadingUserSmtpCredentials || isLoadingLastKnownSmtpCredentials;

  return {
    defaultSmtpCredentialId,
    smtpCredentialsOptions,
    isLoading,
  };
};

const credentialToOption = (
  credential: SmtpCredentialsResponseBody | OAuthEmailCredentialsResponseBody
) => ({
  label: `${credential.title} (${credential.emailAddress})`,
  value: credential.id,
});
